import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import React from "react";
const NOTICE_DURATION_MS = 20000;
export default function ImportNotice({
  message,
  onDismiss,
  saving = false,
  error,
  modal = false,
}) {
  const [visible, setVisible] = React.useState(true);
  const titleId = React.useId();
  React.useEffect(() => {
    if (!visible || onDismiss || modal) return;
    const timer = setTimeout(() => setVisible(false), NOTICE_DURATION_MS);
    return () => clearTimeout(timer);
  }, [visible, onDismiss, modal]);
  if (!visible) return null;
  const dismiss = () => {
    if (!saving) (onDismiss || (() => setVisible(false)))();
  };
  const feedback = error && (
    <Alert role="alert" severity="error">
      {error}
    </Alert>
  );
  const button = (
    <Button
      type="button"
      className="btn"
      autoFocus={modal}
      aria-label={
        error ? "Retry dismissing import notice" : "Dismiss import notice"
      }
      disabled={saving}
      onClick={dismiss}
    >
      {saving ? "Saving…" : error ? "Retry dismissal" : "Dismiss"}
    </Button>
  );
  if (modal)
    return (
      <Dialog
        open
        aria-labelledby={titleId}
        onClose={(_, reason) => {
          if (reason !== "backdropClick") dismiss();
        }}
        slotProps={{
          backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.65)" } },
          paper: { "aria-busy": saving },
        }}
      >
        <DialogTitle id={titleId}>{message}</DialogTitle>
        {feedback && <DialogContent>{feedback}</DialogContent>}
        <DialogActions>{button}</DialogActions>
      </Dialog>
    );
  return (
    <div className="import-notice">
      <p role="status">{message}</p>
      {feedback}
      {button}
    </div>
  );
}
